import { useState, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigation } from '../../utils/NavigationContext';
import { getQrDataFieldType } from '../../lib/getQrDataFieldType';
import FileDisplayPDF from '../../components/FileDisplayPDF';
import LoadingSpinner from '../../components/LoadingSpinner';
import API from '../../API';

export default function FileDisplay() {
    const { id } = useParams();
    const { setShowNavigation } = useNavigation();
    const [qrObj, setQrObj] = useState({ id: '', data: {} });
    const qrDataType = getQrDataFieldType(qrObj?.data?.qr_type || '', [qrObj?.data?.qr_type]);

    const defaultFile = useMemo(() => qrObj?.data?.[qrDataType]?.files[0] || { url: '' }, [qrDataType, qrObj?.data, qrObj?.data?.[qrDataType]?.files]);
    const fileToServe = useMemo(() => defaultFile?.url || '', [defaultFile?.url]);

    useEffect(() => {
        let isMounted = true;
        const { getQR } = API;
        setShowNavigation(false);

        const handleGetQR = async () => {
            try {
                const qr = await getQR(id);
                if (qr) isMounted && setQrObj({ id: id, data: qr });
            } catch (err) {
                console.error('Error gettings QR for file display: ', err?.message || '');
            };
        };

        if (!qrObj.id) {
            handleGetQR();
        };

        return () => {
            isMounted = false;
            setQrObj(null);
            setShowNavigation(true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!fileToServe) return <LoadingSpinner />;

    return <FileDisplayPDF fileToServe={fileToServe} />;
};
